/*
 * @typedef MetaInfo {
 * {String} open   Открывающий тэг с атрибутами
 * {String} close  Закрывающий тэг
 * {Number} start  Индекс первого символа
 * {Number} end    Индекс последнего символа
 * }
 */

/**
 * Получение текста из DOM дерева с его метаданными
 * @param  {Node} node               Корневой узел
 * @param  {Array<MetaInfo>} meta    Массив метаданных для каждого узла
 * @param  {String} text             Аккамулятор текста
 * @return {String}                  Текст без тэгов
 */
export var htmlToText = function htmlToText(node) {
    var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var text = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    for (var i = 0, length = node.childNodes.length; i < length; i++) {
        text = htmlToText(node.childNodes[i], meta, text);
    }

    if (node.nodeType !== Node.TEXT_NODE) {
        return text;
    }

    var nodeValue = node.nodeValue;


    if (!nodeValue) {
        return text;
    }

    var prevMeta = meta.length && meta[meta.length - 1];
    var start = text.length;
    var end = start + nodeValue.length - 1;

    var _getNodeSignature = getNodeSignature(node.parentNode),
        open = _getNodeSignature.open,
        close = _getNodeSignature.close;

    if (prevMeta && open === prevMeta.open) {
        prevMeta.end = end;
    } else {
        meta.push({
            open: open,
            close: close,
            start: start,
            end: end
        });
    }

    return text + nodeValue;
};

/**
 * Преобразование текста в html текст по метаданным
 * @param  {String} text             Текст
 * @param  {Array<MetaInfo>} meta    Метаданные
 * @return {String}
 */
export var textToHtml = function textToHtml(text, meta, overflowText) {
    var result = '';
    var metaLength = meta.length;
    var i = -1;

    while (++i < metaLength) {
        var _meta$i = meta[i],
            open = _meta$i.open,
            close = _meta$i.close,
            start = _meta$i.start,
            end = _meta$i.end;


        if (start >= text.length) {
            break;
        }

        var content = text.substring(start, end + 1) + (i + 1 === metaLength ? overflowText : '');

        result += '' + open + content + close;
    }

    return result;
};

/**
 * С помощью clientRects считаем количество строчек
 * Так как каждая строка может быть разбита на несколько
 * прямоугольников, то вычисляем по кол-во строк по верхней
 * позиции прямоугольников.
 * @param  {Node} domNode
 * @return {Number}
 */
export var getRowsCount = function getRowsCount() {
    for (var _len = arguments.length, domNode = Array(_len), _key = 0; _key < _len; _key++) {
        domNode[_key] = arguments[_key];
    }

    return getRects(domNode).reduce(function (aux, rect, index, source) {
        return index === 0 || source[index - 1].top !== rect.top ? aux + 1 : aux;
    }, 0);
};

/**
 * С помощью clientRects считаем количество строчек
 * Так как каждая строка может быть разбита на несколько
 * прямоугольников, то вычисляем по кол-во строк по верхней
 * позиции прямоугольников.
 * @param  {Node} domNode
 * @return {Number}
 */
export var getRowsWidth = function getRowsWidth() {
    for (var _len2 = arguments.length, domNode = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        domNode[_key2] = arguments[_key2];
    }

    return getRects(domNode).reduce(function (aux, rect, index, source) {
        if (index === 0 || source[index - 1].top !== rect.top) {
            aux.unshift(0);
        }

        aux[0] += rect.width;

        return aux;
    }, []);
};

/**
 * Получение списка clientRects из массива узлов
 * @param {Array<Node>} nodes
 * @return {Array<ClientRect>}
 */
var getRects = function getRects(nodes) {
    return nodes.reduce(function (aux, node) {
        return node ? aux.concat(Array.prototype.slice.apply(node.getClientRects())) : aux;
    }, []);
};

/**
 * Получение открывающего и закрывающего тэгов узла
 * @param  {HTMLElement} node
 * @param  {String} node.nodeType
 * @param  {String} node.nodeName
 * @param  {NamedNodeMap} node.attributes
 * @return {{ open, close }}
 */
var getNodeSignature = function getNodeSignature(_ref) {
    var nodeType = _ref.nodeType,
        nodeName = _ref.nodeName,
        attributes = _ref.attributes;

    var attributesString = Array.prototype.slice.call(attributes).reduce(function (aux, _ref2) {
        var nodeName = _ref2.nodeName,
            nodeValue = _ref2.nodeValue;

        if (nodeName === 'data-reactroot') {
            return aux;
        }

        aux.push(nodeName + '="' + nodeValue + '"');
        return aux;
    }, []).join(' ');

    if (nodeName.toLowerCase() === 'span' && !attributesString) {
        return {
            open: '',
            close: ''
        };
    }

    return {
        open: '<' + nodeName + ' ' + attributesString + '>',
        close: '</' + nodeName + '>'
    };
};